import { memo } from 'react';
import { BaseEdge, getBezierPath, type EdgeProps } from '@xyflow/react';
import type { EditorEdge } from '../../domain/editor-graph';

/**
 * SPEC-006 EDGE-REQ-038 — an edge whose persisted type is not recognized by
 * this editor version. Rendered read-only (no label editing, muted color)
 * so the connection stays visible without implying it can be reclassified.
 */
export const UnknownEdge = memo(function UnknownEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
  markerEnd,
}: EdgeProps<EditorEdge>) {
  const [path] = getBezierPath({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition });
  return (
    <BaseEdge
      id={id}
      path={path}
      markerEnd={markerEnd}
      style={{
        stroke: selected ? 'var(--df-text-brand)' : '#6b6f6c',
        strokeWidth: 1.5,
        strokeDasharray: '2 3',
      }}
    />
  );
});
